import { useState, useEffect } from "react";
import "./Support.scss";
import { useLocation } from "react-router-dom";
import Banner from "../../../Common/Banner/Banner";
import { SUPPORT_INFO } from "../../Sustainability/SustainabilityData";
import iconPathURL from "../../../Common/iconPath";

const iconPath = process.env.PUBLIC_URL + "/assets/images/";

export default function Support() {
  const location = useLocation();
  const [imgPath, setImgPath] = useState("");

  useEffect(() => {
    if (location.pathname == "/support-23") {
      setImgPath(iconPath + "sustainability-23/sustain_header23.png");
    } else if (location.pathname == "/support-24") {
      setImgPath(iconPath + "sustainability-24/sustainability_24_header.png");
    } else if (location.pathname == "/support-25") {
      setImgPath(iconPath + "sustainability-25/sustainability_25_header.png");
    }
  }, [location]);

  const supportTable = () => {
    return (
      <div className="support-content">
        <div
          style={{
            // color: "#d3d3d3",
            // backgroundColor: "white",
            // height: 1,
            // width: 20,
            // alignSelf: "flex-start",
            marginBottom: 10,
            marginTop: 10,
          }}
        />

        <div className="date-text">{SUPPORT_INFO.title1}</div>

        <div className="mail-content">
          <img
            className="img-icon"
            src={iconPathURL("common/mail.png")}
            alt="img"
          ></img>
          <span>
            {" "}
            <a
              className="email-link"
              href="mailto:sustainabilitydialogueindia@mercedes-benz.com"
            >
              sustainabilitydialogueindia@mercedes-benz.com
            </a>
          </span>
        </div>

        <div className="date-text">{SUPPORT_INFO.title2}</div>
        <ul className="date-text">
          <li>{SUPPORT_INFO.p1}</li>
          <li>{SUPPORT_INFO.p2}</li>
          <li>{SUPPORT_INFO.p3}</li>
          <li>{SUPPORT_INFO.p4}</li>
          <li>{SUPPORT_INFO.p5}</li>
          <li>{SUPPORT_INFO.p6}</li>
          <li>{SUPPORT_INFO.p7}</li>
        </ul>
      </div>
    );
  };

  return (
    <div className="support-container">
      <Banner className="banner-content" imgSrc={imgPath} title="" />
      {supportTable()}
    </div>
  );
}
